import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'src/redux'

export const selectQualificationConfig = createSelector(
  (state: RootState) => state,
  (state) => state.qualificationConfig
)
